import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import {
  ButtonComponent,
  IconComponent,
  ResolvableModal,
  TranslatePipe,
} from '@softline/ui-core';

@Component({
  selector: 'soft-palett-modus-change-dialog',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [ButtonComponent, IconComponent, TranslatePipe],
  template: `
    <div class="flex flex-col gap-4 p-4">
      <div class="flex items-center gap-2">
        <soft-ds-icon name="fa-regular fa-circle-info" color="info" size="lg" />
        <span>{{ message() | translate }}</span>
      </div>
      <soft-ds-button variant="primary" (click)="resolve(undefined)">
        {{ '#DELIVERY_NOTE.DIALOGS.PALETT_MODUS_CHANGE.CONFIRM' | translate }}
      </soft-ds-button>
    </div>
  `,
})
export class PalettModusChangeDialogComponent extends ResolvableModal<void> {
  readonly message = input.required<string>();
}
